import { createAction } from 'typesafe-actions';
import { Dispatch } from 'redux';
import {
    GET_APP_CONFIG_REQUEST,
    GET_APP_CONFIG_SUCCESS,
    GET_APP_CONFIG_FAILURE,
    APP_INIT_SUCCESS,
    SET_APP_VIEW,
} from './appConfigConstants';
import {
    AppView,
    HydratedCurriculumFinderConfig,
} from '../Common/types/AppConfigTypes';
import {
    getContentTypesFailure,
    getContentTypesRequest,
    getContentTypesSuccess,
    queryContentTypes,
} from '../Catalog/catalogActions';
import { combineAppConfigWithContentTypes } from './appConfigHelpers';
import { getCFAppConfig } from './appConfigQuery';
import { initializeFilterStateAction } from '../Filter/filterActions';
import { initializeComparisonStateAction } from '../Comparison/comparisonActions';
import { setActiveSlug } from '../List/listActions';
import { activeCTSlugSelector } from '../List/listSelectors';
import { GetState } from '../Common/store/rootReducer';

export const setAppView = createAction(SET_APP_VIEW)<AppView>();

export const getAppConfigRequest = createAction(GET_APP_CONFIG_REQUEST)();
export const getAppConfigSuccess = createAction(GET_APP_CONFIG_SUCCESS)<
    HydratedCurriculumFinderConfig
>();
export const getAppConfigFailure = createAction(GET_APP_CONFIG_FAILURE)<
    Error
>();

export const initializeAppSuccess = createAction(APP_INIT_SUCCESS)();
export const initializeApp = () => async (
    dispatch: Dispatch,
    getState: GetState,
) => {
    dispatch(getAppConfigRequest());
    const appConfigPromise = getCFAppConfig();
    dispatch(getContentTypesRequest());
    const contentTypesPromise = queryContentTypes();

    Promise.all([appConfigPromise, contentTypesPromise])
        .then(result => {
            const appConfig = result[0];
            const contentTypes = result[1].data.getContentTypes;

            if (!appConfig) {
                dispatch(
                    getAppConfigFailure(
                        new Error('Something went wrong with app config fetch'),
                    ),
                );
                return;
            }

            if (!contentTypes) {
                dispatch(
                    getContentTypesFailure(
                        new Error(
                            'Something went wrong with content types fetch',
                        ),
                    ),
                );
            }

            const curriculumTypes = combineAppConfigWithContentTypes(
                appConfig.config,
                contentTypes,
            );

            const hydratedCurriculumFinderConfig = {
                curriculumTypes,
            };

            dispatch(getContentTypesSuccess(contentTypes));
            dispatch(getAppConfigSuccess(hydratedCurriculumFinderConfig));

            if (!activeCTSlugSelector(getState())) {
                dispatch(setActiveSlug(curriculumTypes[0].slug));
            }

            dispatch(initializeFilterStateAction(curriculumTypes));
            dispatch(initializeComparisonStateAction(curriculumTypes));
            dispatch(initializeAppSuccess());
            return result;
        })
        .catch(error => {
            console.error(error);
            dispatch(getAppConfigFailure(error));
            dispatch(getContentTypesFailure(error));
            return;
        });
};
